import axiosInstance from './axios';

export const medicalApi = {
    getSurveyStatusOverview: async function(season) {
        try {
            /*
            return new Promise((resolve, reject) => {
                axiosInstance.get(`/causes/sub${cause_id ? `?causeId=${cause_id}` : ''}`).then((resp) => {
                    resolve(resp.data);
                }).catch(() => {
                    resolve([]);
                });
            })
                */
            const response = await axiosInstance.get(`/medical/reports?season=${season}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching survey status overview:', error);
            throw error;
        }
    },
}